import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScheduledMessageIdsStorageService {
  scheduledMessageId: number = 0;
  scheduledMessageIds: number[] = [];

  constructor() {}
}
